export const STEP_TYPES = {
  welcome: 'welcome',
  yesNo: 'yesNo',
  singleChoice: 'singleChoice',
  multiChoice: 'multiChoice',
  loader: 'loader',
  final: 'final',
  shortYesNo: 'shortYesNo',
  shortSingleChoice: 'shortSingleChoice',
  shortFinal: 'shortFinal',
};

export const HEADER_TYPES = {
  unlock: 'unlock',
  ready: 'ready',
};

const LONG_FUNNEL = [
  { name: 'welcome', type: STEP_TYPES.welcome },
  {
    name: 'dating_experience',
    type: STEP_TYPES.yesNo,
    progress: 0,
    header: HEADER_TYPES.unlock,
  },
  {
    name: 'nearby',
    type: STEP_TYPES.yesNo,
    progress: 28,
    header: HEADER_TYPES.unlock,
  },
  {
    name: 'goal',
    type: STEP_TYPES.singleChoice,
    progress: 52,
    header: HEADER_TYPES.unlock,
  },
  {
    name: 'age_difference',
    type: STEP_TYPES.singleChoice,
    progress: 76,
    header: HEADER_TYPES.unlock,
  },
  {
    name: 'payment',
    type: STEP_TYPES.singleChoice,
    progress: 82,
    header: HEADER_TYPES.ready,
  },
  {
    name: 'important',
    type: STEP_TYPES.multiChoice,
    progress: 98,
    header: HEADER_TYPES.ready,
  },
  {
    name: 'loader',
    type: STEP_TYPES.loader,
    exitProgress: 99,
    header: HEADER_TYPES.ready,
    isHeaderLoader: true,
    skipHistory: true,
  },
  { name: 'final', type: STEP_TYPES.final },
];

const SHORT_QUESTIONS = [
  { name: 'dating_experience', type: STEP_TYPES.shortYesNo },
  { name: 'nearby', type: STEP_TYPES.shortYesNo },
  { name: 'age_difference', type: STEP_TYPES.shortSingleChoice },
];

const SHORT_FUNNEL = [
  ...SHORT_QUESTIONS,
  { name: 'final', type: STEP_TYPES.shortFinal },
];

const CHRISTIAN_FUNNEL = [
  { name: 'faith', type: STEP_TYPES.shortSingleChoice },
  { name: 'share', type: STEP_TYPES.shortSingleChoice },
  { name: 'distance', type: STEP_TYPES.shortSingleChoice },
  { name: 'final', type: STEP_TYPES.shortFinal },
];

const FUNNELS = {
  long: LONG_FUNNEL,
  short: SHORT_FUNNEL,
  christian: CHRISTIAN_FUNNEL,
};

export const FUNNEL_NAME = FUNNELS[window.FUNNEL] ? window.FUNNEL : 'long';

export const STEPS = FUNNELS[FUNNEL_NAME];

export const USES_SHORT_STEPS = STEPS.some((step) => step.type === STEP_TYPES.shortFinal);

export const THEME = FUNNEL_NAME === 'christian' ? 'christian' : null;

export const ANSWER_FEEDBACK_MS = THEME === 'christian' ? 300 : 0;

export const SHORT_QUESTION_NAMES = STEPS.filter(
  (step) => step.type === STEP_TYPES.shortYesNo || step.type === STEP_TYPES.shortSingleChoice,
).map((step) => step.name);

export const FIRST_STEP_NAME = STEPS[0].name;

export const STEP_INDEX_BY_NAME = STEPS.reduce((acc, step, index) => {
  acc[step.name] = index;

  return acc;
}, {});

export const PROGRESS_STEP_NAMES = STEPS.filter(
  (step) => step.progress !== undefined || step.isHeaderLoader,
).map((step) => step.name);

export const LOADER_DURATION = 4500;
export const LOADER_PHRASE_INTERVAL = 1000;
export const LOADER_FIRST_PHRASE_DELAY = 1600;
export const LOADER_MORPH_DELAY = 500;

export const STEP_TRANSITION_MS = 600;

export const VISIT_LINK_BASE = 'https://kismia.com/l';
export const DEFAULT_TOC = 'W2Qws8';
export const TOC_PARAM = 'toc';

export const CSS_PARAM = 'css';
